import { PartitionOutlined } from '@ant-design/icons'
import styled from 'styled-components'

import { colorStyles, fontSizeStyles } from './styles'
import { IconProps } from './types'

const PartitionOutlinedIconStyled = styled(PartitionOutlined)<Pick<IconProps, '$color' | '$size'>>`
  ${colorStyles}
  ${fontSizeStyles}
`

export default PartitionOutlinedIconStyled
